import React from 'react';
import i18n from 'i18next';

// types
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';

// constants

// helpers
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    gridTunables,
    legendTunables,
    metaInfoTunables,
    xAxisTunables,
    yAxisTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import { widgetDimIsDate } from 'utils/Widget/WidgetUtils';

export const HyperSpaceStackedBarChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => {
    const isTimeDim: boolean = widgetDimIsDate(widget);
    return [
        {
            props: {
                label: i18n.t('Stacked Bar Chart'),
                startOpen: true,
            } as CollapseProps,
            children: [...headerTunables(widget), opacityTunables(widget), gridTunables(widget)],
        },
        metaInfoTunables({ widget, color: true, image: false }),
        xAxisTunables({ widget, ticks: true, mergedTheme, axisIsDim: false }),
        yAxisTunables({ widget, ticks: true, format: isTimeDim, mergedTheme }),
        legendTunables(widget, { metric: false }),
    ];
};
